
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Head } from 'vite-react-ssg'
import { getCanonicalUrl } from '../utils/canonical'
import { getReport } from '../services/api'
import ScanResults from '../components/ScanResults'

export default function ReportDetailPage() {
  const { reportId } = useParams<{ reportId: string }>()
  
  const { data: report, isLoading } = useQuery({
    queryKey: ['report', reportId],
    queryFn: () => getReport(reportId!),
    enabled: !!reportId,
  })

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
        <div className="animate-pulse space-y-4">
          <div className="h-8 bg-gray-200 rounded w-1/3"></div>
          <div className="h-4 bg-gray-200 rounded w-2/3"></div>
          <div className="h-4 bg-gray-200 rounded w-1/2"></div>
        </div>
      </div>
    )
  }

  if (!report) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-6">
        <h2 className="text-lg font-semibold text-red-900">Report Not Found</h2>
        <p className="text-red-700 mt-1">
          The requested report could not be found.
        </p>
      </div>
    )
  }

  return (
    <>
      <Head>
        <title>Report Details - Accessibility Checker</title>
        <meta name="description" content="View detailed accessibility scan report" />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href={getCanonicalUrl(`/reports/${reportId}`)} />
      </Head>
      <ScanResults scanId={report.scanId} />
    </>
  )
}
